export const TicketOrigin = {
    WEB: 'WEB',
    TPV: 'TPV',
}